module.exports = __webpack_public_path__ + "img/29_26.4e39ad0f.png";